<div class="left-panel">
  <div class="logo-container">
    <img src="assets/brand/myvvid-logo-portrait-reversed.svg" alt="Logo" class="logo" />
  </div>

  <div class="middle-images">
    <img src="assets/images/left-card-map.png" class="map" alt="World Map" />
    <img src="assets/images/left-card-social.png" class="network" alt="People Network" />
  </div>

  <div class="caption">
    <p>
      Be part of the global community that uses hivve's products to capture, measure and report on
      their impact to create a more sustainable world.
    </p>
  </div>

  <div class="footer">
    <div class="mb-0">
      <app-legal-links></app-legal-links>
      <app-copyright></app-copyright>
    </div>
  </div>
</div>
